/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common examples`)
};

const es_cr_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejemplos comunes`)
};

const de_cr_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Häufige Beispiele`)
};

const nl_cr_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veelvoorkomende voorbeelden`)
};

const fr_cr_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exemples courants`)
};

const it_cr_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esempi comuni`)
};

const pt_br2_cr_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exemplos comuns`)
};

const pt_cr_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exemplos comuns`)
};

const ja_cr_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般的な例`)
};

const zh_cr_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常见示例`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_examples_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_examples_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_examples_title", locale)
	if (locale === "en") return en_cr_examples_title(inputs)
	if (locale === "es") return es_cr_examples_title(inputs)
	if (locale === "de") return de_cr_examples_title(inputs)
	if (locale === "nl") return nl_cr_examples_title(inputs)
	if (locale === "fr") return fr_cr_examples_title(inputs)
	if (locale === "it") return it_cr_examples_title(inputs)
	if (locale === "pt-BR") return pt_br2_cr_examples_title(inputs)
	if (locale === "pt") return pt_cr_examples_title(inputs)
	if (locale === "ja") return ja_cr_examples_title(inputs)
	return zh_cr_examples_title(inputs)
};